export const ROLE_SUMMARY_TITLE = "INFORMAÇÕES DO PERFIL";
